<template>
  <v-container fluid class="login-bg fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="6" lg="4">
        <v-card class="login-card" elevation="12">
          <v-toolbar color="primary" dark flat class="login-toolbar">
            <v-toolbar-title class="font-weight-bold">
              岩槻タッチログ
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text class="pa-8">
            <div class="text-center mb-6">
              <div class="text-h5 font-weight-bold mb-2">Login</div>
              <div class="subtitle-2 grey--text text--darken-1">
                ユーザーIDとパスワードを入力してください
              </div>
            </div>

            <!-- ボタン押下時に post() 実行 -->
            <v-form @submit.prevent="post">
              <v-text-field v-model="authId" label="User ID" prepend-inner-icon="mdi-account-circle" outlined dense
                clearable class="mb-3" />

              <v-text-field v-model="authPass" :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" label="Password" prepend-inner-icon="mdi-lock"
                outlined dense class="mb-2" @click:append="showPassword = !showPassword" />

              <v-btn type="submit" color="primary" large block class="mt-4 login-btn font-weight-bold" elevation="2">
                Log In
              </v-btn>

              <v-alert v-if="msg" class="mt-5" type="error" dense outlined>
                {{ msg }}
              </v-alert>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
//Login.vue
export default {
  name: 'Login',
  //data定義
  data() {
    return {
      showPassword: false,//password表示(デフォルトは非表示)
      msg: '',//メッセージ表示される
      authId: '',//入力されたuserID
      authPass: ''//入力されたpassword
    }
  },
  //methods定義(非同期通信)→ボタン押した時のイベント
  methods: {
    //バックエンドにHTTPでPOST送信
    post() {
      //入力値の前後スペース削除→スペースのみの場合は、空文字になる
      const id = (this.authId || '').trim()
      const pass = (this.authPass || '').trim()

      const data = { id, pass }
      //axiosでPOST通信（'/login'にdataを送信）
      this.$axios.post('/api/touch/login', data)


        //ログイン成功時の処理
        .then((response) => {
          //console.log(response);
          this.msg = response.data.message;
          if (this.msg === 'OK') {
            //ユーザIDをstoreに保存
            this.$store.dispatch('fetch', id)
            //遷移後、storeからユーザIDを取得して表示するために、Page1へ遷移
            this.$router.push('/iwatsuki/TouchLog')
          }
        })
        //ログイン失敗時の処理
        .catch((error) => {
          //console.log('catch response:', error?.response?.data)
          this.msg = error?.response?.data?.message || error.message
        });
    }
  }
};
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  background: linear-gradient(135deg, #e3f2fd 0%, #f5f7fa 50%, #e8eaf6 100%);
}

.login-card {
  border-radius: 20px;
  overflow: hidden;
}

.login-toolbar {
  min-height: 64px;
}

.login-btn {
  border-radius: 10px;
  text-transform: none;
  letter-spacing: 0.5px;
}
</style>